<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 26/02/2018-->
<!--//Time: 10:59-->

<template>
    <div class="dashboard-module-small d-flex justify-content-between align-items-top">
        <div class=" d-flex justify-content-center align-items-center ">
            <div>
                <div class="dashboard-module-small--icon" :style="'background-color:'+ icon.color">
                    <div class="d-flex align-items-center">
                        <i class="material-icons">shopping_cart</i>
                    </div>
                    <div class="dashboard-module--counter number_circle">
                        {{settings.sale_count}}
                    </div>
                </div>
            </div>
            <div>
                <h6 class="dashboard-module-small--title" v-html="settings.title"></h6>
                <div class="dashboard-module-small--value">{{currency}}{{settings.sale_total}}</div>
            </div>
        </div>

        <actions-menu-module
                @click_events="actionEventHandler"
                :download="{
                    name:settings.file_name + '.' + exportData.type,
                    type:exportData.type,
                    fields:exportData.json_fields,
                    data:exportData.json_data
                }"
        >
        </actions-menu-module>

    </div>
</template>

<script>

	import {SalesComponent} from './SalesComponent';
	import {_} from 'underscore';
	import {getDate, DATE_FORMAT} from "../../../../../app/Shared/Resources/Assets/js/helpers/format.date";

	Vue.component('actions-menu-module', require('./ActionsMenuModule'));

	export default {
		name: "sales-module-small",
		components: {},
		props: {
			/**
			 * @namespace parameters
			 * @property parameters.filter_date
			 * @property parameters.type
			 * @property parameters.data_type
			 */
			parameters: Object,
			request_route_uri: String,
			read_request: String, // string true or string false
			filter_date: String
		},
		created() {
		},
		destroyed() {
		},
		mounted() {
			// console.log('this.parameters', this.parameters);
			this.local_filter_date = this.parameters.filter_date;
			this.$nextTick(function () {
				this.report();
				this.$emit('child_loaded', 'sales-list');
			});
		},
		data() {
			return {
				items: Array,
				local_filter_date: String,
				date_range: Object,
				menu_open: false,
				loadingDataSet:false,
				currency: '£',
				icon: {
					color: '#044b63'
				},
				exportData: {
					type: 'csv',
					json_fields: {
						'Complete name': 'name',
						'City': 'city',
						'Telephone': 'phone.mobile',
						'Telephone 2': {
							field: 'phone.landline',
							callback: (value) => {
								return `Landline Phone - ${value}`;
							}
						},
					},
					json_data: [
						{
							'name': 'Tony Peña',
							'city': 'New York',
							'country': 'United States',
							'birthdate': '1978-03-15',
							'phone': {
								'mobile': '1-541-754-3010',
								'landline': '(541) 754-3010'
							}
						},
						{
							'name': 'Thessaloniki',
							'city': 'Athens',
							'country': 'Greece',
							'birthdate': '1987-11-23',
							'phone': {
								'mobile': '+1 855 275 5071',
								'landline': '(2741) 2621-244'
							}
						}
					],
					json_meta: [
						[
							{
								'key': 'charset',
								'value': 'utf-8'
							}
						]
					],
				},
				settings: {
					title: 'sales',
					sale_total: 0,
					sale_count: 0,
					start_date: '',
					date_database_format: {
						start: '',
						end: ''
					},
					frequency: ''
				},
				dateChooser: {
					show_form: false,
					display: false
				},
				salesComponent: {}
			}
		},
		methods: {
			report() {
				// console.log(this,'this.parameters',this.parameters);
				let _this = this,
					data = {
						module_type: _this.parameters.type,
						type: _this.parameters.data_type,
						frequency: _this.parameters.frequency,
						filter_date: getDate(_this.local_filter_date, 'data_base'),
					};

				// console.log('read() data', data);
				return axios.post(this.request_route_uri, data)
					.then(function (response) {
						if (response.data.success) {
							_this.items = response.data.sales;
							_this.date_range = response.data.date;
							_this.loadingDataSet = false;
						}else{
							throw new Error('Request failed');
                        }
						// console.log('_this.dashboards', _this.dashboards);
						return _this.itemsChanged();
					})
					.catch(function (e) {
						console.error('Error:', e);
					});
			},
			actionEventHandler(obj) {
				switch (obj.action) {
					case 'download':

						break;
					case 'calendar':
						this.openCalendar();
						break;
				}

			},
			exportToCsv() {
				console.log('export', this);
			},
			openCalendar() {
				// console.log('this.parameters', this.parameters);
				// this.dateChooser.display = !this.dateChooser.display;
				// console.log('this.dateChooser',this.dateChooser);
				this.$emit('open_calendar', {
					index: this.parameters.index
				});

			},
			reloadWithRange(value) {
				this.local_filter_date = new Date(value);
				return this.report();

			},
			itemsChanged() {

				this.salesComponent = new SalesComponent(this.parameters, 'sales');

				let _this = this,
					_settings = this.salesComponent._setDateRangeRaw(_this.parameters, _this.date_range);

				return _this.settings = _this.salesComponent.setSalesValueFilter({
					sale_total:_this.items.sale_total,
					sale_count:_this.items.sale_count
                }, _settings);
			},
		},
		computed: {},
		watch: {
			filter_date(date) {
				this.reloadWithRange(date).$nextTick(function () {
					this.$emit('layout_changed');
				});
			},
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/SalesModuleSmall.vue?330dfac8